export { default } from './DismissablePromotionDone';
